<template>
	<div class="c-dashboard__wrap"
        :data-component-name="$options.name"
	>
		<div class="c-help">
			<h1 class="o-form__title">Aide</h1>
			<h2 class="o-form__title -hidden-mobile">Manuel de l'utilisateur</h2>
			<div class="o-row">
				<div class="col-12 details">
					<a href="/files/GuideUtilisateurRIFF.pdf" target="_blank" style="font-weight:800">Cliquez ici</a> pour télécharger le manuel de l'utilisateur au format PDF.
				</div>
			</div>

			<div class="splitter"></div>


			<h2 class="o-form__title" v-if="userProfiles && userProfiles.length>0">Support technique</h2>
			<div class="o-row -colors" v-if="userProfiles && userProfiles.length>0">
				<div class="col" :key="ui" v-for="(userProfile, ui) in userProfiles">
					<div class="-details" style="padding-top: 0px;">
						<div class="-label">
							{{userProfile.name }}
						</div>
						<div class="-caption">
							<div v-if="(userProfile.title && userProfile.title.trim()!='') || (userProfile.company && userProfile.company.name.trim()!='')">
								<span v-if="userProfile.title && userProfile.title.trim()!=''">
									{{ userProfile.title }}<span v-if="userProfile.company.name">, </span>
								</span>
								<span v-if="userProfile.company && userProfile.company.name.trim()!=''">
									{{ userProfile.company.name }}
								</span>
							</div>
							<div v-if="userProfile.email && userProfile.email.trim()!=''" class="-nowrap">
								<q-icon name="mail" class="q-mr-xs" />
								<a :href="'mailto: ' + userProfile.email">{{ userProfile.email }}</a>
							</div>
							<div v-if="userProfile.phone_work && userProfile.phone_work.trim()!=''" class="-nowrap">
								<q-icon name="business" class="q-mr-xs" />
								<a :href="'tel: ' + userProfile.phone_work">{{ userProfile.phone_work }}</a>
							</div>
							<div v-if="userProfile.phone_mobile && userProfile.phone_mobile.trim()!=''" class="-nowrap">
								<q-icon name="phone_iphone" class="q-mr-xs" />
								<a :href="'tel: ' + userProfile.phone_mobile">{{ userProfile.phone_mobile }}</a>
							</div>
							<div v-if="userProfile.phone_home && userProfile.phone_home.trim()!=''" class="-nowrap">
								<q-icon name="home" class="q-mr-xs" />
								<a :href="'tel: ' + userProfile.phone_home">{{ userProfile.phone_home }}</a>
							</div>
						</div>
					</div>
				</div>
			</div>


			<div class="splitter" v-if="userProfiles && userProfiles.length>0"></div>


			<h2 class="o-form__title -hidden-mobile">Raccourcis clavier</h2>

			<div class="o-row -hidden-mobile">

				<div class="col">
					<div class="-shortcut">
						<div class="-key">
							Ctrl
						</div>
						<div>
							+
						</div>
						<div class="-key">
							k
						</div>
					</div>
					<div class="-details">
						<div class="-label">
							Rechercher
						</div>
						<div class="-caption">
							Lancer une nouvelle recherche
						</div>
					</div>
				</div>

				<div class="col">
					<div class="-shortcut">
						<div class="-key">
							Ctrl
						</div>
						<div>
							+
						</div>
						<div class="-key">
							n
						</div>
					</div>
					<div class="-details">
						<div class="-label">
							Nouveau projet
						</div>
						<div class="-caption">
							Créer un nouveau projet à partir de la section <a hre="/projects">Projets</a>
						</div>
					</div>
				</div>

				<div class="col">
					<div class="-shortcut">
						<div class="-key">
							Ctrl
						</div>
						<div>
							+
						</div>
						<div class="-key">
							Alt
						</div>
						<div>
							+
						</div>
						<div class="-key">
							Z
						</div>
					</div>
					<div class="-details">
						<div class="-label">
							Mois précédent
						</div>
						<div class="-caption">
							Ce déplacer vers le mois précédent à partir des sections <a hre="/projects">Projets</a> et <a href="/staff">Employés</a>
						</div>
					</div>
				</div>

				<div class="col">
					<div class="-shortcut">
						<div class="-key">
							Ctrl
						</div>
						<div>
							+
						</div>
						<div class="-key">
							Alt
						</div>
						<div>
							+
						</div>
						<div class="-key">
							X
						</div>
					</div>
					<div class="-details">
						<div class="-label">
							Mois suivant
						</div>
						<div class="-caption">
							Ce déplacer vers le mois suivant à partir des sections <a hre="/projects">Projets</a> et <a href="/staff">Employés</a>
						</div>
					</div>
				</div>
				<div class="col">
					<div class="-shortcut">
						<div class="-key">
							Ctrl
						</div>
						<div>
							+
						</div>
						<div class="-key">
							Alt
						</div>
						<div>
							+
						</div>
						<div class="-key">
							<q-icon class="rotate-180" name="arrow_right_alt"></q-icon>
						</div>
					</div>
					<div class="-details">
						<div class="-label">
							Semaine précédente
						</div>
						<div class="-caption">
							Ce déplacer vers la semaine précédente à partir des sections <a hre="/projects">Projets</a>, <a href="/staff">Employés</a> et <a href="/schedule">Horaire</a>
						</div>
					</div>
				</div>

				<div class="col">
					<div class="-shortcut">
						<div class="-key">
							Ctrl
						</div>
						<div>
							+
						</div>
						<div class="-key">
							Alt
						</div>
						<div>
							+
						</div>
						<div class="-key">
							<q-icon name="arrow_right_alt"></q-icon>
						</div>
					</div>
					<div class="-details">
						<div class="-label">
							Semaine suivante
						</div>
						<div class="-caption">
							Ce déplacer vers la semaine suivante à partir des sections <a hre="/projects">Projets</a>, <a href="/staff">Employés</a> et <a href="/schedule">Horaire</a>
						</div>
					</div>
				</div>
				
				<div class="col">
					<div class="-shortcut">
						<div class="-key">
							Ctrl
						</div>
						<div>
							+
						</div>
						<div class="-key">
							Alt
						</div>
						<div>
							+
						</div>
						<div class="-key">
							Shift
						</div>
						<div>
							+
						</div>
						<div class="-key">
							<q-icon class="rotate-180" name="arrow_right_alt"></q-icon>
						</div>
					</div>
					<div class="-details">
						<div class="-label">
							Journée précédente
						</div>
						<div class="-caption">
							Ce déplacer vers la journée précédente à partir des sections <a hre="/projects">Projets</a> et <a href="/staff">Employés</a>
						</div>
					</div>
				</div>
				
				<div class="col">
					<div class="-shortcut">
						<div class="-key">
							Ctrl
						</div>
						<div>
							+
						</div>
						<div class="-key">
							Alt
						</div>
						<div>
							+
						</div>
						<div class="-key">
							Shift
						</div>
						<div>
							+
						</div>
						<div class="-key">
							<q-icon name="arrow_right_alt"></q-icon>
						</div>
					</div>
					<div class="-details">
						<div class="-label">
							Journée suivante
						</div>
						<div class="-caption">
							Ce déplacer vers la semaine / mois suivant à partir des sections <a hre="/projects">Projets</a> et <a href="/staff">Employés</a>
						</div>
					</div>
				</div>

			

			</div>

			<div class="splitter -hidden-mobile"></div> 

			<h2 class="o-form__title  -hidden-mobile">Chartes des couleurs</h2>

			<div class="o-row -colors  -hidden-mobile">

				<div class="col">
					<div class="-color__wrap">
						<div class="-color green">
							
						</div>
					</div>
					<div class="-details">
						<div class="-label">
							Complété / Approuvé
						</div>
						<div class="-caption">
							La teinte est utilisée pour afficher l'état complété d'un projet ou une affectation acceptée par l'utilisateur.
						</div>
					</div>
				</div>
				
				<div class="col">
					<div class="-color__wrap">
						<div class="-color blue">
							
						</div>
					</div>
					<div class="-details">
						<div class="-label">
							En attente
						</div>
						<div class="-caption">
							La teinte est utilisée pour afficher l'état en attente d'acceptation d'un projet ou d'une affectation.
						</div>
					</div>
				</div>

				<div class="col">
					<div class="-color__wrap">
						<div class="-color yellow">
							
						</div>
					</div>
					<div class="-details">
						<div class="-label">
							Brouillon non publié
						</div>
						<div class="-caption">
							La teinte est utilisée pour indiquer qu'un projet précédemment publié contient des informations brouillons non publiées.
						</div>
					</div>
				</div>

				<div class="col">
					<div class="-color__wrap">
						<div class="-color red">
							
						</div>
					</div>
					<div class="-details">
						<div class="-label">
							Erreur / Affectation refusée
						</div>
						<div class="-caption">
							La teite est utilisée pour attirer l'attention sur un projet contenant une erreur, un conflit d'horaire ou une affectation refusée par l'utilisateur
						</div>
					</div>
				</div>

				<div class="col">
					<div class="-color__wrap">
						<div class="-color orange">
							
						</div>
					</div>
					<div class="-details">
						<div class="-label">
							Avertissement
						</div>
						<div class="-caption">
							La teinte est utilisée pour attirer l'attention sur un projet qui contient un avertissement ou une erreur non critique.
						</div>
					</div>
				</div>

				<!-- <div class="col">
					<div class="-color__wrap">
						<div class="-color pink">
							
						</div>
					</div>
					<div class="-details">
						<div class="-label">
							Journée précédente
						</div>
						<div class="-caption">
							Ce déplacer vers la journée précédente à partir de la section <a hre="/projects">Projets</a>
						</div>
					</div>
				</div> -->

				<div class="col">
					<div class="-color__wrap">
						<div class="-color grey">
							
						</div>
					</div>
					<div class="-details">
						<div class="-label">
							Brouillon
						</div>
						<div class="-caption">
							La teinte est utilisée pour afficher l'état brouillon non publié d'un projet ou d'une affectation
						</div>
					</div>
				</div>
				

			</div>
		</div>
	</div>
</template>

<script>
	import {USERPROFILES} from '@/graphql/user/queries'

	export default {
		name: "Help",
		data(){
			return {
				userProfileIDs: [],
				skipQuery: true
			}
		},
		methods: {
		},
		mounted(){
			if(this.$generalSettings.settings?.superUserProfiles && this.$generalSettings.settings?.superUserProfiles?.trim()!=""){
				this.userProfileIDs=this.$generalSettings.settings.superUserProfiles.split(',');
				this.skipQuery=false;
			}
		},
		apollo: {
			userProfiles: {
				query: USERPROFILES,
				fetchPolicy: 'cache-and-network',	//cache-first, cache-and-network, cache-only, network-only, no-cache -> https://v4.apollo.vuejs.org/guide-composable/query.html#fetch-policy
				skip(){
					return this.skipQuery
				},
				//debounce: 200,
				error(error){
					if (error.message) this.$q.notify({type: 'negative', message: 'Oh Oh', caption: error.message});
				},
				variables() {
					return {
						ids: this.userProfileIDs
					}
				},
				update(userProfiles) {
					return userProfiles.userProfiles.data
				},
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import "@/scss/views/Dashboard.scss";
</style>

<style lang="scss">
	.c-app.c-help-vue {
		overflow: visible;
	}
	.c-help{
		background-color: white;
		height: 100%;
		display: flex;
		flex-direction: column;
		padding: 60px;
		@include media("<md") {
			padding: 60px 40px;
		}
		& .splitter {
			width: 100%;
			border-bottom: 1px solid $color-0-light;
			margin-bottom: 40px;
		}

		.col-12 {
			width: 100%;
			margin-right: 40px;
			margin-bottom: 40px;
		}
		.col {
			width: calc(33% - 40px);
			margin-right: 40px;
			margin-bottom: 40px;
			min-width: 310px;
			max-width: 310px;
			width: 310px;

			//display: flex;
			//flex-direction: row;
			//align-items: flex-start;

			@include media("<md") {
				min-width: 100%;
				max-width: 100%;
				width: 100%;
			}

			& .-details {
				padding-top: 12px;
				//padding-left: 20px;
				color: $color-1-dark;
				
				width: 170px;

				& .-label {
					font-weight: 800;
					font-size: 12px;
					line-height: 20px;
					margin-bottom: 6px;
				}
				& .-caption {
					font-weight: 500;
					font-size: 11px;
					line-height: 18px;
				}
			}

		}

		.-color {
			width: 30px;
			height: 30px;
			border-radius: 15px;

			&.blue {
				background-color: $color-6;
			}

			&.yellow {
				background-color: $color-2;
			}

			&.red {
				background-color: $color-4;
			}
			&.orange {
				background-color: $color-3;
			}
			&.pink {
				background-color: $color-5;
			}
			&.green {
				background-color: $color-8;
			}

			&.grey {
				background-color: $color-0;
			}
		}

		.o-row.-colors .-details {
			flex-grow: 1;
		}

		.-key {
			display: inline-flex;
			background-color: $color-6;
			color: $white;
			border-radius: 2px;
			padding: 0 5px;
			font-weight: 800;
			font-size: 12px;
			min-height: 30px;
			min-width: 30px;
			line-height: 30px;
			text-align: center;
			flex-direction: row;
			align-items: center;
			justify-content: center;

			& .q-icon {
				font-size: 16px;
			}
		}

		.o-row {
			max-width: 1200px;
			justify-content: left;
		}

		.-shortcut {
			font-size: 12px;
			font-weight: 800;
			color: $color-0;
			display: flex;
			flex-direction: row;
			align-items: center;
			flex-grow: 1;
			min-width: 140px;

			& > div {
				margin-right: 4px;
			}
		}

		.-nowrap {
			white-space: nowrap;
		}
	}
</style>